import { Document } from './document';
import { CustomsBroker } from './customs-broker';

export enum ManifestStatus {
  IN_PROGRESS = 'in progress',
  FAILURE = 'failed',
  SUCCESS = 'successful',
}

export interface ManifestOptions {
  customsBroker?: CustomsBroker;
}

export interface Manifest {
  id: string;
  documents: Document[];
  status: ManifestStatus;
  options: ManifestOptions;
}

export interface ManifestLogEvent {
  level: string;
  timestamp: string;
  manifestJobId: string;
  message: string;
}

export type ManifestEventLog = ManifestLogEvent[];
